import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-order-state-label',
  templateUrl: './order-state-label.component.html',
  styleUrls: ['./order-state-label.component.scss']
})
export class OrderStateLabelComponent {

  public readonly TX_STATE_CANCELLED: number = 600;

  @Input('txState') m_txStateId: number;
  @Input('deliveryState') m_deliveryState: number;

}
